import FormField from './FormField'

export default function Select({
  id,
  label,
  value,
  onChange,
  options = [],
  placeholder,
  required = false,
  error,
  disabled = false,
  className = '',
}) {
  return (
    <FormField id={id} label={label} required={required} error={error} className={className}>
      <select
        id={id}
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        aria-describedby={error ? `${id}-error` : undefined}
        aria-required={required}
        className="input-base"
      >
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {options.map((opt) => (
          <option key={opt.value ?? opt} value={opt.value ?? opt}>
            {opt.label ?? opt}
          </option>
        ))}
      </select>
    </FormField>
  )
}
